import { GET_BUG_REPORTS_SUCCESS, UPDATE_BUG_REPORT_SUCCESS } from '../actions/bugReportsActionTypes';

const initialState = {
  reports: {},
  institutions: {},
  tags: {},
};

export default function users(state = initialState, action) {
  switch (action.type) {
    case GET_BUG_REPORTS_SUCCESS:
      return action.data;
    case UPDATE_BUG_REPORT_SUCCESS:
      return {
        ...state,
        reports: {
          ...state.reports,
          [action.data.id]: action.data,
        },
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/bugReportsReducer.js